import React from "react"
import Button from "../../common/blocks/button/Button"
import Card from "../../common/blocks/card/Card"
import CtxHeroSection from "../../common/sections/ctx-hero-section/CtxHeroSection"
import * as classNames from './HeroHeaderTagsListSection.module.scss'
import { sectorUrl } from "../../../../utils/routeLib"
function HeroHeaderTagsListSection({ Title, image, imgSrc, sectors, currentSector }) {
  return (
    <CtxHeroSection 
      image={image} 
      imgSrc={imgSrc}
      classes={classNames.hero}
    >
      <div className="container">
        <Card className="card_bottom text-center p-6 gap-4 flex flex-direction-column justify-content-center fade-in-bottom">
          <h2>{Title}</h2>
          <div className="tags justify-content-center">
            {sectors.map((item, i) => {
              const isCurrentSector = currentSector === item.attributes.name
              return (
                <Button
                  key={i}
                  className={`${isCurrentSector ? "active" : ""}`}
                  to={sectorUrl(item.attributes.slug)}
                  disabled={isCurrentSector ? "true" : "false"}
                  aspect="tag"
                  color="secondary"
                >
                  {item.attributes.name}
                </Button>
              )
            })}
          </div>
        </Card>
      </div>
    </CtxHeroSection>
  )
}
export const name = "HeroHeaderTagsListSection"

export const init = (componentData, pageContext) => {
  console.log(JSON.stringify(componentData, undefined, 2))
  return (
    <HeroHeaderTagsListSection
      key={componentData.id}
      Title={componentData.title}
      image={componentData.image}
      imgSrc={componentData.image?.data?.attributes?.url}
      sectors={pageContext.sectors}
      currentSector={pageContext.itemData?.attributes?.name}
    />
  )
}

export default HeroHeaderTagsListSection
